import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Dashboard from './pages/Dashboard';
import VenueDetail from './pages/VenueDetail';
import AreaBuilder from './pages/AreaBuilder';
// DesignBrief import removed - feature hidden from UI but backend preserved
import SubmissionReview from './pages/SubmissionReview';
import SubmissionSuccess from './pages/SubmissionSuccess';
import AssessmentSummary from './pages/AssessmentSummary';
import AdminHub from './pages/AdminHub';
import AdminSubmissionDetail from './pages/AdminSubmissionDetail';
import ExplorePage from './pages/ExplorePage';
import ExperienceViewer from './pages/ExperienceViewer';
import GuidePage from './pages/GuidePage';
import PublicGuidePage from './pages/PublicGuidePage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public routes - no auth required */}
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/experience/:submissionId" element={<PublicGuidePage />} />
            
            {/* Legacy experience viewer route */}
            <Route path="/experience-legacy/:id" element={<ExperienceViewer />} />
            
            {/* Auth routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/venue/:venueId"
              element={
                <ProtectedRoute>
                  <VenueDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/venue/:venueId/area/new"
              element={
                <ProtectedRoute>
                  <AreaBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/venue/:venueId/area/:areaId"
              element={
                <ProtectedRoute>
                  <AreaBuilder />
                </ProtectedRoute>
              }
            />
            {/* Design Brief route removed - feature hidden from UI */}
            <Route
              path="/venue/:venueId/submission/:submissionId/review"
              element={
                <ProtectedRoute>
                  <SubmissionReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/submission/:submissionId/success"
              element={
                <ProtectedRoute>
                  <SubmissionSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/submission/:submissionId/summary"
              element={
                <ProtectedRoute>
                  <AssessmentSummary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminHub />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/submission/:submissionId"
              element={
                <ProtectedRoute>
                  <AdminSubmissionDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/guide/:submissionId"
              element={
                <ProtectedRoute>
                  <GuidePage />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<ExplorePage />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;